module.exports = "<p [innerHTML]=\"bodyContent\"></p>\n"